import React from 'react';

import { Button } from 'components/ui/button';
import { Dialog } from '@buildoutinc/blueprint-react/ui/Dialog';

interface Props {
  show: boolean;
  onDelete: () => void | Promise<void>;
  onHide: () => void;
}

export default function DeleteModal({ show, onDelete, onHide }: Props) {
  async function handleDelete() {
    await onDelete();
    onHide();
  }

  return (
    <Dialog open={show} onClose={onHide}>
      <Dialog.Content>
        <Dialog.Header>
          <Dialog.Title>Delete Task</Dialog.Title>
        </Dialog.Header>
        <Dialog.Body>
          <p>Are you sure you want to delete this task?</p>
        </Dialog.Body>
        <Dialog.Footer>
          <Dialog.Cancel>Cancel</Dialog.Cancel>
          <Button label="Delete" variant="destructive" onClick={handleDelete} />
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  );
}
